export const PACKAGE_NAME = 'jiraNavigationAppsHorizontalNavJsmProjectSummary';
export const TEAM_NAME = 'jsd-shield';
